import { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useFormikContext } from 'formik'
import { SemiConfigFormValues, SemiConfigClone } from '../ProductsConfiguration'
import useSearch from '../useSearch'
import ClonesTable from './TableComponents/ClonesTable'

const PreDesignedControls = () => {
  const formik = useFormikContext<SemiConfigFormValues>()
  const [searchResults, setSearchResults] = useState<SemiConfigClone[]>([])
  const { searchQuery } = useSearch()

  useEffect(() => {
    const loadData = async () => {
      const data = await searchQuery({})
      if (data && typeof data === 'object') {
        if (data?.controls) {
          const result = data?.controls.map((control) => {
            return {
              ...control,
              price: '',
              currency: '',
            }
          })
          setSearchResults(result)
        } else {
          setSearchResults([])
        }
      } else {
        setSearchResults([])
      }
    }
    loadData()
  }, [formik.values.searchData])

  return (
    <ClonesTable
      tableTitle={
        <FormattedMessage
          id="CONF_Pre_Designed_Control_crisprgrna"
          defaultMessage="Predesigned Controls"
        />
      }
      tableData={searchResults}
      totalCount={searchResults.length}
    />
  )
}

export default PreDesignedControls
